import React from "react";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { distance } from "./geo.js";
import Chip from "@material-ui/core/Chip";
import { navigate } from "@reach/router";
import FavoriteIcon from "@material-ui/icons/Favorite";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import { makeStyles } from "@material-ui/core/styles";

const dataStore = require("./dataStore.js");
const useStyles = makeStyles({
  root: {
    // maxWidth: 345,
    font: "Noto Sans JP"
  },
  actionButton: {
    padding: "6px"
  },
  media: {
    height: 200,
    padding: "0px"
  },
  cardActions: {
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "8px",
    paddingBottom: "16px",
    flexWrap: "wrap"
  },
  cardContent: {
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "8px",
    paddingBottom: "8px"
  }
});

function Category(props) {
  return (
    <Chip
      label={props.name}
      variant="outlined"
      title={props.name}
      onClick={props.onClick || false}
      color={props.color || (props.selected ? "primary" : "default")}
    />
  );
}

export function categoryChip(key, name, onClick, selected) {
  var color = name === dataStore.deliveryDuringLockdownCategory && "secondary";
  return (
    <Category
      key={key}
      name={name}
      color={color}
      onClick={e => onClick && onClick(e, name)}
      selected={selected}
    />
  );
}
export function CYTCard(props) {
  const classes = useStyles();
  const categoriesChips =
    props.provider.categories &&
    props.provider.categories.map(categoryName =>
      categoryChip(
        `${categoryName}-${props.id}`,
        categoryName,
        props.onCategoryClick,
        props.selectedCategories &&
          props.selectedCategories.includes(categoryName.toLowerCase())
      )
    );

  var distanceToCurrentGeoposition = null;
  if (props.currentGeopos && props.provider.geopoint) {
    const kms = distance(
      props.currentGeopos.lat,
      props.currentGeopos.lon,
      props.provider.geopoint.latitude,
      props.provider.geopoint.longitude
    );
    if (kms < 1) {
      distanceToCurrentGeoposition = `A ${Math.round(kms * 1000)}mts`;
    } else if (kms < 10) {
      distanceToCurrentGeoposition = `A ${Math.round(kms)}kms`;
    }
  }
  return (
    <Card key={props.provider.id} style={props.style} className={classes.root}>
      <CardActionArea>
        {props.provider.photo && (
          <CardMedia className={classes.media} image={props.provider.photo} />
        )}
        <CardContent className={classes.cardContent}>
          <Typography
            variant="h5"
            component="h2"
            onClick={e => {
              navigate("/p/" + props.provider.id);
              e.preventDefault();
            }}
          >
            <a
              style={{ color: "inherit", "text-decoration": "none" }}
              href={"/p/" + props.provider.id}
            >
              {props.provider.name}
            </a>
            <CYTLike
              liked={props.liked}
              className={classes.actionButton}
              onClick={e => props.onClick && props.onClick(e)}
            />
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {props.provider.what}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {props.provider.location}
          </Typography>

          {distanceToCurrentGeoposition}
        </CardContent>
        <CardActions className={classes.cardActions}>
          {categoriesChips}
        </CardActions>
      </CardActionArea>
    </Card>
  );
}

function CYTLike(props) {
  //  type='checkbox' checked={props.liked}
  return (
    <IconButton {...props} onClick={e => props.onClick && props.onClick(e)}>
      {props.liked ? <FavoriteIcon /> : <FavoriteBorderIcon />}
    </IconButton>
  );
}
